export const INSURANCE_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
}

export const TRACKING_ZONES = {
  POLICIES_AND_ELIGIBLE_INSURANCES:
    'services-hub-policies-and-eligible-insurances',
  POLICY_DETAILS: 'services-hub-policy-details',
  ELIGIBLE_INSURANCES: 'services-hub-eligible-insurances',
  NO_POLICIES_OR_ELIGIBLE_INSURANCES:
    'services-hub-no-policies-or-eligible-insurances',
}

export const MODAL_NAMES = {
  COVERAGE_DETAILS_DRAWER: 'coverage-details-drawer',
  PAYMENT_HISTORY_DRAWER: 'payment-history-drawer',
}

export const PARTNER_WEBSITE_URL = {
  EVY: 'https://backmarket.customers.evy.eu/en',
  BOLT: 'https://selfservice.boltinsurance.com/prod/ui/backmarket/account/login',
  I_SURANCE_SAKURA: 'https://backmarket.bolttech.jp/#/ ',
  ASURION:
    'https://protection.asurion.com/protection-plan/en-us/?cid=vn-rtm:backmarket',
  I_SURANCE_CARDIF: 'https://backmarket.bolttech.eu/',
  I_SURANCE_WAKAM: 'https://backmarket-uk.bolttech.eu/',
}
